import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Check, Loader2 } from 'lucide-react';
import Header from '@/components/join/Header';
import Footer from '@/components/join/Footer';
import { Button } from '@/components/ui/button';

const Success: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const sessionId = location.search.split('=')[1];

  useEffect(() => {
    // You could verify the payment here with another edge function
    console.log('Payment successful - session ID:', sessionId);

    // Auto-redirect to the checkout success page after 3 seconds
    const redirectTimer = setTimeout(() => {
      navigate('/checkout-success');
    }, 3000);

    return () => clearTimeout(redirectTimer);
  }, [sessionId, navigate]);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleContinue = () => {
    navigate('/checkout-success');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow flex items-center justify-center py-12">
        <div className="container max-w-2xl">
          <div className="bg-white rounded-xl p-8 text-center shadow-lg">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
              <Check className="h-8 w-8 text-green-600" />
            </div>

            <h1 className="text-3xl font-bold mb-4">Payment Successful!</h1>

            <p className="text-gray-600 mb-6">
              Thank you for your purchase! Your credits have been locked in.
            </p>

            <div className="mb-6 flex items-center justify-center">
              <div className="flex items-center text-primary">
                <Loader2 className="h-5 w-5 animate-spin mr-2" />
                <span>Redirecting to your welcome page...</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={handleGoHome} variant="outline" className="w-full sm:w-auto">
                Back to Home
              </Button>

              <Button onClick={handleContinue} className="w-full sm:w-auto">
                Continue to Welcome
              </Button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Success;
